/* eslint-disable @stencil-community/required-jsdoc */

import { Component, Host, h, State, getAssetPath, Prop } from '@stencil/core';
import { AvailableLocales } from '../../layouts/default-layout/default-layout.types';
import state from '../../../store/store';

@Component({
  tag: 'efb-ethias-baseline',
  styleUrl: 'ethias-baseline.scss',
  shadow: true,
  assetsDirs: ['assets'],
})
export class EfbEthiasBaseline {
  /**
   * State
   */

  @State() language: AvailableLocales;

  /**
   * Props
   */

  @Prop() orange?: boolean;

  @Prop() noMargin?: boolean;

  /**
   * Lifecycle hooks
   */

  componentWillRender() {
    this.language = state.currentLanguage;
  }

  /**
   * Render
   */

  render() {
    const themeColor = this.orange ? '-orange' : '';
    const baselineText =
      this.language === 'nl' ? 'We zijn er voor je. Ethias' : 'Nous sommes là pour vous. Ethias';
    const baselineWidth = this.language === 'nl' ? '207' : '281';

    return (
      <Host>
        <img
          class={`ethias-baseline ${this.noMargin ? 'no-margin' : ''}`}
          src={getAssetPath(`assets/ethias-baseline${themeColor}-${this.language}.svg`)}
          alt={baselineText}
          width={baselineWidth}
          height="46"
        />
      </Host>
    );
  }
}
